import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ShoppingBag, Layers, Handshake, Sparkles, TrendingUp } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1758448500717-2e4bcd79108b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  const why = [
    { icon: ShoppingBag, t: "One Destination", d: "Multiple categories under one retail ecosystem." },
    { icon: Layers, t: "Curated Choice", d: "Products and brands selected around customer needs." },
    { icon: Handshake, t: "Local + Branded", d: "Recognised brands combined with curated local vendors." },
    { icon: Sparkles, t: "Modern Experience", d: "Clean, organized and technology-enabled shopping." },
    { icon: TrendingUp, t: "Built to Grow", d: "Designed from the beginning for multi-city expansion." },
  ];
  return (
    <div>
      <div className="px-3 md:px-6 pt-4">
        <div className="relative h-72 overflow-hidden rounded-3xl">
          <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-midnight/75" />
          <div className="relative h-full flex flex-col justify-center px-8 md:px-16 max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white">About KRVMart</h1>
            <p className="mt-3 text-white/80">A modern multi-category retail concept developed by KRV Nexus Pvt Ltd, bringing everyday essentials, fashion, furniture, and technology together through an organized and customer-focused retail experience.</p>
          </div>
        </div>
      </div>

      <section className="mx-auto max-w-[1100px] px-4 md:px-8 py-16">
        <Reveal>
          <div className="rounded-3xl border border-border p-8 text-center">
            <p className="text-sm font-bold uppercase tracking-widest text-gold-dark">KRV Nexus Pvt Ltd → KRVMart</p>
            <p className="mt-3 text-lg text-muted-foreground">KRVMart is the retail brand of KRV Nexus Pvt Ltd — <span className="italic text-midnight">Where Vision Becomes Value.</span></p>
            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
              {[["Home Mart", "#4A7C59", "/home-mart"], ["Style Mart", "#C77F76", "/style-mart"], ["Wood Mart", "#A45C40", "/wood-mart"], ["Tech Mart", "#00A8E8", "/tech-mart"]].map(([n, c, to]) => (
                <Link key={n} to={to} className="rounded-2xl border border-border p-4 hover:shadow-lg transition-shadow"><span className="block h-1.5 w-10 mx-auto rounded-full mb-2" style={{ background: c }} /><span className="font-bold text-midnight">{n}</span></Link>
              ))}
            </div>
          </div>
        </Reveal>

        <h2 className="mt-16 mb-8 text-center text-3xl font-extrabold text-midnight">Why KRVMart?</h2>
        <div className="grid md:grid-cols-3 gap-5">
          {why.map((w, i) => (
            <Reveal key={w.t} delay={i * 0.06}>
              <div className="rounded-3xl border border-border p-6 h-full">
                <div className="grid h-11 w-11 place-items-center rounded-2xl bg-midnight text-gold"><w.icon className="h-5 w-5" /></div>
                <h3 className="mt-4 text-lg font-extrabold text-midnight">{w.t}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{w.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-12 rounded-3xl bg-midnight p-8 text-center text-white">
            <h3 className="text-2xl font-extrabold">Our Long-Term Vision</h3>
            <p className="mt-2 text-white/70 max-w-2xl mx-auto">KRVMart is being designed as a scalable multi-category retail concept, built to grow from one flagship store to a multi-city retail ecosystem — through standardized stores, category systems, technology and operational processes.</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
